import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { setConventions } from '../store/slices/conventionsSlice'
import { resolveConventions } from '../core/conventions/resolveConventions'

export function useLoadConventions({ brand, currency }) {
  const dispatch = useDispatch()

  useEffect(() => {
    if (!brand || !currency) return
    dispatch(setConventions(resolveConventions({ brand, currency })))
  }, [brand, currency, dispatch])
}
